var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.suppliersList)?_c('v-autocomplete',{attrs:{"preset-val":"1","error-messages":_vm.errors,"disabled":_vm.isDisabled,"items":_vm.suppliersList,"label":_vm.suppliersLabel},on:{"change":_vm.suppliersChange},model:{value:(_vm.idSupplier),callback:function ($$v) {_vm.idSupplier=$$v},expression:"idSupplier"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }